<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span class="go-back" [attr.aria-hidden]="true" (click)="redirectTo()">
      <img src="assets/images/arrow-left.svg" alt="" />Destination Countries
    </span>
    <img src="assets/images/arrow-right.svg" alt="" />
    <ng-container *ngIf="!isEdit">New</ng-container>
    <ng-container *ngIf="isEdit">Edit</ng-container>
    Destination Country
  </div>
  <form
    class="mat-form"
    [formGroup]="upsertDestCountryForm"
    (ngSubmit)="onSubmit()">
    <div class="row mt-2">
      <div class="col-12">
        <mat-card>
          <mat-card-title class="h4">Source Country</mat-card-title>
          <mat-divider class="position-relative mb-3"></mat-divider>
          <div class="row">
            <div class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onSourceCountryChange($event)"
                [inputData]="attrConstant.srcCountryName"
                [selectOptions]="sourceCountryList | async"
                [bindLabel]="'countryName'"
                [bindValue]="'countryName'"
                [formControlName]="
                  attrConstant.srcCountryName.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.srcCountryCode"
                [formControlName]="
                  attrConstant.srcCountryCode.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.srcCountryAlpha2Code"
                [formControlName]="
                  attrConstant.srcCountryAlpha2Code.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.srcCurrencySupported"
                [formControlName]="
                  attrConstant.srcCurrencySupported.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.srcMobileCode"
                [formControlName]="
                  attrConstant.srcMobileCode.key
                "></app-input-template>
            </div>
          </div>
        </mat-card>
        <mat-card class="mt-2">
          <mat-card-title class="h4">Destination Country</mat-card-title>
          <mat-divider class="position-relative mb-3"></mat-divider>
          <div class="row">
            <div class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onDestCountryChange($event)"
                [inputData]="attrConstant.destCountryName"
                [selectOptions]="countryList | async"
                [bindLabel]="'country_name'"
                [bindValue]="'country_name'"
                [formControlName]="
                  attrConstant.destCountryName.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.destCountryCode"
                [formControlName]="
                  attrConstant.destCountryCode.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.destCountryAlpha2Code"
                [formControlName]="
                  attrConstant.destCountryAlpha2Code.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.destCurrencySupported"
                [formControlName]="
                  attrConstant.destCurrencySupported.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.destMobileCode"
                [formControlName]="
                  attrConstant.destMobileCode.key
                "></app-input-template>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <button class="btn primary-btn w-100 mt-3">Submit</button>
  </form>
</div>
